<div class="modal-header">
  <h4 class="modal-title">{{detail.subject || '(no subject)'}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="mb-2">
    <div><strong>From:</strong> {{detail.from}}</div>
    <div><strong>To:</strong> {{detail.to.join(', ')}}</div>
    @if (detail.cc.length > 0) {
      <div><strong>Cc:</strong> {{detail.cc.join(', ')}}</div>
    }
    <div><strong>Sent:</strong> {{detail.sentDate}}</div>
    <div><strong>Received:</strong> {{detail.receivedDate}}</div>
    <div><strong>Folder:</strong> {{detail.folder}}</div>
    <div><strong>Message-ID:</strong> {{detail.messageId}}</div>
    @if (detail.flags.length > 0) {
      <div><strong>Flags:</strong> {{detail.flags.join(', ')}}</div>
    }
  </div>

  <button type="button" class="btn btn-sm btn-outline-secondary mb-2" (click)="downloadRaw()">Download raw (.eml)</button>

  @if (detail.attachments.length > 0) {
    <div class="mb-2">
      <strong>Attachments:</strong>
      <ul>
        @for (attachment of detail.attachments; track attachment.index) {
          <li>
            <a href="javascript:void(0)" (click)="downloadAttachment(attachment)">
              {{attachment.fileName || ('attachment-' + attachment.index)}}
            </a>
            ({{attachment.contentType}}, {{attachment.sizeBytes}} bytes)
          </li>
        }
      </ul>
    </div>
  }

  <hr />

  @if (detail.htmlBody) {
    <iframe class="mail-body-frame" title="Email HTML content" sandbox="allow-same-origin" [srcdoc]="detail.htmlBody"></iframe>
  } @else if (detail.textBody) {
    <pre class="mail-body-text">{{detail.textBody}}</pre>
  } @else {
    <div class="text-muted">(no body)</div>
  }

  <details class="mt-3">
    <summary>Headers</summary>
    <table class="table table-sm">
      <thead class="visually-hidden">
        <tr><th scope="col">Header</th><th scope="col">Value</th></tr>
      </thead>
      <tbody>
        @for (entry of headerEntries; track entry[0]) {
          <tr>
            <td>{{entry[0]}}</td>
            <td>{{entry[1].join(', ')}}</td>
          </tr>
        }
      </tbody>
    </table>
  </details>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close()">Close</button>
</div>
